import React, { ReactNode } from 'react';
import { Flex } from 'antd';
import CustomImage from './CustomImage';
import CustomShipmentText from './CustomShipmentText';

interface ShowMessageProps {
  icon?: string;
  heading: string;
  text: string;
  themeColor?: string;
  children?: ReactNode;
  paragraphFontSize?: string;
}

const ShowMessage: React.FC<ShowMessageProps> = ({
  icon,
  heading,
  text,
  themeColor,
  children,
  paragraphFontSize = '16px',
}) => {
  return (
    <>
      <div className='show-message-container'>
        <Flex justify='center' style={{ marginBottom: '24px' }}>
          {icon && (
            <Flex
              className='zl-verify-img'
              align='center'
              justify='center'
              style={{
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                backgroundColor: themeColor,
              }}
            >
              <CustomImage src={icon} alt='' preview={false} />
            </Flex>
          )}
        </Flex>

        <CustomShipmentText
          className='auth-title'
          text={heading}
          fontSize='32px'
          fontWeight='700'
          lineHeight='40px'
          marginBottom='12px'
          textAlign='center'
        />

        <CustomShipmentText
          text={text}
          className='auth-description'
          fontSize={paragraphFontSize}
          lineHeight='24px'
          marginBottom='24px'
          textAlign='center'
        />

        {children}
      </div>
    </>
  );
};

export default ShowMessage;
